import * as z from "zod";

import { parseMoney } from "~/utilities/money";

// `moneyInputPattern` matches an amount as entered by a user, in major currency
// units, with an optional decimal part.
export const moneyInputPattern = /^\d+([.,]\d+)?$/;

export function createMoneyInputSchema(currencyCode: string, locale: string) {
  return z
    .string()
    .min(1, "Amount is required")
    .regex(moneyInputPattern, "Invalid amount format")
    .refine((val) => {
      const result = parseMoney(val, currencyCode, locale);
      return !isNaN(result) && result > 0;
    }, "Please enter a valid positive amount")
    .transform((val) => {
      return parseMoney(val, currencyCode, locale);
    });
}
